import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SettingsIcon from '@mui/icons-material/Settings';

interface IconConfigurationProps {
  title: string;
}

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    color: palette.neutral[100],
  },
}));

export const ConfigurationIcon = ({ title }: IconConfigurationProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.title}>
      <SettingsIcon sx={{ fontSize: '20px' }} />
      {title}
    </div>
  );
};

export default ConfigurationIcon;
